import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["ean"]

  search() {
    // console.dir(this.eanTarget.value);
  }
}
